<template>
  <header class="header-wrapper">
    <div class="ws-header hd-header-background-color hd-header-color hd-header-fontsize">
      <div class="container ws-header__inner d-flex justify-content-between align-items-center">
        <router-link aria-label="Home" :to="{ name: linkName, query: { secret: secret } }">
          <div style="min-width: 100px; min-height: 20px">
            <img
              v-if="airline && airline.template_config && airline.template_config.logo_header_mobile"
              class="ws-logo"
              :src="airline.template_config.logo_header_mobile"
              alt="Airline Picture"
            />
          </div>
        </router-link>
        <div style="cursor: pointer">
          <div v-show="pax.lang && pax.lang.lang_code" class="langcode">
            <div
              id="lang_title"
              role="button"
              :aria-label="`Select language. Current: ${pax.lang ? pax.lang.name || pax.lang.lang_code : ''}`"
              :aria-expanded="showLangList.toString()"
              tabindex="0"
              class="lang_title language-option"
              @click="showLangList = !showLangList"
              @keydown.enter="showLangList = !showLangList"
              @keydown.space.prevent="showLangList = !showLangList"
              @keydown.esc="showLangList = false"
            >
              <i class="fa fa-language" aria-hidden="true" style="font-size: 32px"></i>
              &nbsp;<span v-if="pax.lang">{{ pax.lang.lang_code }}</span>
            </div>
            <transition v-if="airline.langs && airline.langs.length > 1" name="lang-fade">
              <div v-if="showLangList" role="menu" class="lang_list" :aria-label="`Language selection menu`">
                <ul>
                  <template v-for="lang in airline.langs">
                    <li
                      v-if="lang.lang_code !== pax.lang.lang_code"
                      :key="lang.lang_code"
                      @click="changeLang(lang.lang_code)"
                      @keydown.enter="changeLang(lang.lang_code)"
                      @keydown.space.prevent="changeLang(lang.lang_code)"
                    >
                      <span>{{ lang.name }}</span>
                    </li>
                  </template>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import '@/assets/scss/modules/Header.scss'

export default {
  name: 'Header',
  props: {
    secret: {
      type: String,
      default: ''
    },
    linkName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showLangList: false
    }
  },
  created() {
    document.addEventListener('click', (evt) => {
      const flyoutElement = document.getElementById('lang_title')
      let targetElement = evt.target

      do {
        if (targetElement == flyoutElement) {
          return
        }
        targetElement = targetElement.parentNode
      } while (targetElement)
      this.showLangList = false
    })
  },
  methods: {
    changeLang: function (langCode) {
      this.$store.dispatch('header/updatePassengerLanguage', langCode).then((response) => {
        if (response.success) {
          location.reload()
        }
      })
    }
  }
}
</script>
